import { autoinject } from "aurelia-framework";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { BudgetClientModel } from "@rightship-tech/common-ui/models/rightstore/rightstore.models";

@autoinject
export class BudgetClientService {

    public budgetBaseUrl: string = `${this.configService.config.urls.rightStoreApiUrl}/api/Budget`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }

    //Get all budgets for a business unit
    public getAllByBusinessUnitId(businessUnitId: number) {
        return this.requestClientService.get<BudgetClientModel[]>(`${this.budgetBaseUrl}/all/${businessUnitId}`, {}) as Promise<BudgetClientModel[]>;
    }
    
    public async getCreditBalance(businessUnitId: number): Promise<number> {
        let clientBudgets = await this.getAllByBusinessUnitId(businessUnitId);
        return clientBudgets.reduce((acc, val) => { return acc + val.remainingCredits }, 0)
    }
}